module.exports = __webpack_public_path__ + "static/media/about-warsaw-poster-1.60176ea0.png";